// extracted by mini-css-extract-plugin
module.exports = {"illustration":"FrontPageCard_illustration__AAfgf","frontPageCard":"FrontPageCard_frontPageCard__cJV53"};